<template>
  <section class="flex">

      <header class="container-1">
          <h3 class="apanam">APANAM</h3>
          <h1>Shop
</h1>
      
      <img src="../../assets/underline.png" alt="">


      <h4>We offer transformative online and offline yoga classes for kids, aged three to <br> fifteen. </h4>
     
      </header>
   
  </section>

</template>

<script>
export default {

}
</script>

<style scoped>

 .apanam{
color: #791E94;
    font-weight: 450;
 }  
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 70px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}

h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}
.flex{
    display: flex;
    justify-content: flex-start;
    padding-top: 12rem;
        width: 90%;
    margin: auto;
    height: 432px;
    flex-wrap: wrap;
}
.container-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
}
body{
    background: #FFFFF2;
}


</style>>

